import * as Yup from "yup";

export const OtherItemValidation = Yup.object({
    name: Yup.string().required("Item is required!"),
    otherItemStatusId: Yup.number().required("Status is required!"),
})